"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setUser = exports.customEvent = exports.createEvent = void 0;
const initialize_1 = require("../initialize");
const time_1 = require("./time");
const setUser = (userId) => {
    initialize_1.default.identify(userId);
};
exports.setUser = setUser;
const customEvent = (data, eventName) => {
    initialize_1.default.track(eventName, data);
};
exports.customEvent = customEvent;
const createEvent = (gaConfig) => {
    const { eventCategory, eventAction, eventLabel, eventPage, eventSubCategory, eventValue, eventValueType, event_name = "select_content", sendGA3 = true, } = gaConfig;
    if (sendGA3) {
        /* Track a custom event for old GA */
        initialize_1.default.track("gtm.event", {
            eventCategory: checkEmptyString(eventCategory),
            eventAction: eventAction,
            eventLabel: checkEmptyString(eventLabel),
            eventTimeStamp: (0, time_1.default)(),
        }, () => {
            console.log("G3 Event Created");
        });
        console.log({
            event_name: event_name,
            content_type: eventCategory,
            item_id: eventAction,
            content_sub_type: eventSubCategory,
            event_page: eventPage,
            event_value_type: eventValueType,
            event_value: eventValue, //solve for search
        });
    }
    /* Track a custom event for GA 4 */
    initialize_1.default.track("gtm.ga4event", {
        event_name: event_name,
        content_type: eventCategory,
        item_id: eventAction,
        content_sub_type: eventSubCategory,
        event_page: eventPage,
        event_value_type: eventValueType,
        event_value: eventValue,
    }, () => {
        console.log("G4 Event Created");
    });
};
exports.createEvent = createEvent;
function checkEmptyString(value) {
    if (value === "") {
        return "(not set)";
    }
    return value;
}
